


























import Vue from 'vue';
import {Component} from 'vue-property-decorator';

import CubEventList from '@app/events/EventList.vue';
import CubFooter from '@app/Footer.vue';
import CubHeader from '@app/Header.vue';
import CubNavItem from '@app/nav/NavItem.vue';
import CubNav from '@app/nav/Nav.vue';
import CubNavContainer from '@app/nav/NavContainer.vue';

import {OnCreated} from '@app/types';
import {NavItem} from '@app/store/interfaces/NavItem';
import {FbEvent} from '@app/store/models/FbEvent';

@Component({
    components: {CubEventList, CubFooter, CubHeader, CubNavContainer, CubNav, CubNavItem}
})
export default class CubApp extends Vue implements OnCreated {

    public navActive = false;

    get navItems(): NavItem[] | null {
        return this.$store.getters.navItems;
    }

    get fbEvents(): FbEvent[] | null {
        return this.$store.state.events;
    }

    public created(): void {
        this.$store.dispatch('loadFbEvents');
        this.$store.dispatch('loadPages');
    }

    public showNav(): void {
        this.navActive = true;
    }

    public hideNav(): void {
        this.navActive = false;
    }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/app/App.vue